export const locale = {
  email: "Email",
  password: "Password",
  please_login: "Please Log In",
  login: "Log In",
  remember_me: "Remember Me",
  forgot_password: "Forgot Password",
  search_here: "Search Tags Here...",
  yes: "yes",
  no: "no",
  logoutHeader: "Are you sure you want to log out?",
  logoutBody:
    "By logging out, you will end your current session and be redirected to the login page.",
  goToPage: "Go to page",
  deleteHeader: "Are you sure you want to delete this video?",
  deleteBody:
    "This action cannot be undone. Deleting this video will permanently remove it from the database.",
  close: "close",
  nav_browse: "BROWSE",
  nav_manage: "MANAGE",
  control_selected: "Selected",
  control_play: "Play",
  control_copy: "Copy Link",
  control_download: "Download",
  control_details: "Details",
  control_edit: "Edit",
  control_delete: "Delete",
  control_delete_video: "Delete Video",
  control_retag: "Retag",
  thumbnail_tags: "Tags",
  thumbnail_videolength: "Video Length",
  refresh: "Refresh",
  details: "Details",
  video_title: "Video Title",
  hashtag: "#",
  timestamp: "Timestamp",
  type: "Type",
  tag: "Tag",
  confidence: "Confidence",
  edit_video_details: "Edit Video Details",
  cancel: "cancel",
  save: "save",
  add: "add",
  label: "Label",
  object: "Object",
  ocr: "OCR",
  modify: "Modify",
  mark_for_deletion: "Mark for Deletion",
  unmark_for_deletion: "Unmark for Deletion",
  remove: "Remove",
  save_header: "Save Changes?",
  save_body: "Are you sure you want to save your changes?",
  enter_tag: "Enter tag here",
  time: "Time",
  save_title_body:
    "You are going to update the video title, are you sure you want to save your changes?",
  save_tags_body:
    "You are going to update the tags below, are you sure you want to save your changes?",
  save_dialog_body:
    "You are going to update the video title and the tags below, are you sure you want to save your changes?",
  cancel_header: "Cancel Changes?",
  cancel_dialog_body:
    "The update you made to the video title and tags below will be discarded, are you sure you want to cancel?",
  cancel_title_body:
    "The update you made to the video title below will be discarded, are you sure you want to cancel?",
  cancel_tags_body:
    "The update you made to the video tags below will be discarded, are you sure you want to cancel?",
  search_filter: "Search Filter:",
  transcript_not_editable: "Transcript is not editable",
  all_media: "All Media",
  new_folder: "New Folder",
  folders: "Folders",
  videos: "Videos",
  control_rename: "Rename",
  control_move: "Move",
  destination_instruction: "Select destination folder",
  ok: "Ok",
  no_videos: "No Videos",
  control_delete_folder_header: "Are you sure you want to delete this folder?",
  delete_folder_description:
    "Deleting this folder will also delete its subfolders. Media are still available under “All Media”",
  retag_header: "Add Tag to 1 video",
  retag_header_multiple: "Add Tag to %d Videos",
  retag_description: "The tag will be a type of general",
  add_tag: "Add Tag",
  success_retag: "Tag has been added to 1 video",
  success_retag_multiple: "Tag has been added to %d videos",
  //  STAVC-326 VERT-02 content vertical assignment entry/UI copy.
  control_assign_to_vertical: "Assign to Vertical",
  control_unassign_from_vertical: "Unassign from Vertical",
  assign_dialog_title: "Assign “%s” to verticals",
  assign_current_readback: "Current assignments",
  assign_no_taxonomy: "No verticals are available for assignment.",
  assign_loading_taxonomy: "Loading verticals…",
  assign_loading_readback: "Loading current assignments…",
  assign_saving: "Saving assignment…",
  assign_operation_add: "Add selected",
  assign_operation_remove: "Remove selected",
  assign_operation_reassign: "Reassign all",
  assign_confirm_remove: "Remove %s from this video? Other vertical assignments and folders will remain unchanged.",
  assign_confirm_replace_empty: "Replace this video’s vertical assignments with no verticals? Folders will remain unchanged.",
  assign_confirm_replace: "Replace this video’s vertical assignments with %s? Folders will remain unchanged.",
  assign_retry: "Retry",
  assign_success: "Vertical assignments updated for %s. Folders were not moved.",
  assign_error_forbidden: "You do not have access to assign this video.",
  assign_error_video_missing: "This video is no longer available.",
  general: "General",
  displaySort: "Display Sort (4)",
  filter_category_alphabetical: "Alphabetical",
  filter_category_videoLength: "Video Length",
  filter_category_dateModified: "Date Modified",
  filter_category_dateCreated: "Date Created",
  exportTranscript: "Export Transcript",
  editTag: "Edit Tag",
  deleteTag: "Delete Tag",
  deleteTranscript: "Delete Transcript",
  filter: "Filter",
  transcript: "Transcript",
  search: "Search",
  delete_tags_body:
    "You are going to delete the tag below, are you sure you want to save your changes?",
  delete_transcript_body:
    "You are going to delete the transcript, are you sure you want to save your changes?",
  rename_video_header: "Rename Video",
  rename_video_success: "Video was successfully renamed.",
  cannot_cancel_saving: "You cannot cancel because saving is in progress",
  tag_delete_success: "Tag was successfully deleted.",
  transcript_delete_success: "Transcript was successfully deleted.",
  no_results: "No results found",
  add_tag_header: "Add Tag",
  edit_tag_header: "Edit Tag",
  update: "Update",
  tag_added_success: "Tag was successfully added.",
  tag_updated_success: "Tag was successfully updated.",
  transcript_added_success: "Transcript was successfully added.",
  transcript_updated_success: "Transcript was successfully updated.",
  transcript_export_error: "Error: Encountered an error while exporting transcript. Either there is no transcript available or an error occurred during fetching.",
};
